// src/stores/user.js
import { defineStore } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'
import { fetchUserPreferences, updateUserPreferences } from '../services/UserService'

export const useUserStore = defineStore({
    plugins: [piniaPersist],
    id: 'user',
    state: () => ({
        email: '',
        isLoggedIn: false,
        preferences: {
            theme: localStorage.getItem('theme') || 'light', // Initialize from localStorage
            tip_of_the_day: false // Initialize as needed
        }
    }),
    actions: {
        setEmail(email) {
            this.email = email
        },
        logIn() {
            this.isLoggedIn = true
        },
        logOut() {
            this.isLoggedIn = false
        },
        async fetchPreferences() {
            try {
                const preferences = await fetchUserPreferences()
                this.preferences.theme = preferences.theme || 'light'
                this.preferences.tip_of_the_day = preferences.tip_of_the_day
                this.applyTheme() // Apply theme on preferences fetch
            } catch (error) {
                console.error('Failed to fetch preferences:', error)
            }
        },
        async updatePreferences(preferences) {
            try {
                const updatedPreferences = await updateUserPreferences(preferences)
                this.preferences = { ...this.preferences, ...updatedPreferences }
                this.applyTheme() // Apply theme on preferences update
            } catch (error) {
                console.error('Failed to update preferences:', error)
            }
        },
        toggleTheme() {
            const newTheme = this.preferences.theme === 'light' ? 'dark' : 'light'
            this.preferences.theme = newTheme
            this.updatePreferences({ theme: newTheme })
            this.applyTheme()
        },
        toggleTipOfDay() {
            this.preferences.tip_of_the_day = !this.preferences.tip_of_the_day
            this.updatePreferences({ tip_of_the_day: this.preferences.tip_of_the_day })
        },
        applyTheme() {
            const theme = this.preferences.theme || 'light'
            document.documentElement.setAttribute('data-bs-theme', theme)
            localStorage.setItem('theme', theme)
        }
    },
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'lantern_user',
                storage: localStorage,
                paths: ['email', 'isLoggedIn', 'preferences']
            }
        ]
    }
})
